import { isString } from 'lodash-es';

export type DateString = string;
export function isDateString(arg: unknown): arg is DateString {
  return isString(arg) && /^\d{4}-\d{2}-\d{2}$/.test(arg);
}
export type DateTimeString = string;
export type ISODateTimeString = string;

export enum UnitSystem {
  Metric = 'metric',
  Imperial = 'imperial',
}
